<div class="menuBar">
    <div matRipple (click)="onClick()"><fa-icon [icon]="faSearchPlus"></fa-icon></div>
    <div matRipple (click)="onClick()"><fa-icon [icon]="faSearchPlus"></fa-icon></div>
    <div matRipple (click)="onClick()"><fa-icon [icon]="faSearchPlus"></fa-icon></div>
    <div matRipple (click)="onClick()"><fa-icon [icon]="faSearchPlus"></fa-icon></div>
</div>